import { EmployerAgreementsService_employerAgreementsVersionsServiceGetEntityByQuery } from '@festina/life-general-types/life/hooks/EmployerAgreementsVersionsService_employerAgreementsVersionsServiceGetEntityByQuery'

export const useFetchEmployerAgreementVersionNoSuspense =
  EmployerAgreementsService_employerAgreementsVersionsServiceGetEntityByQuery.useQuery
